module.exports = __webpack_public_path__ + "img/gas.62405c3f.svg";